'use client';

import { useEffect, useState } from 'react';
import { createClient } from '@/utils/supabase/client';
import { useRouter } from 'next/navigation';
import { getUserGroup } from '@/app/actions/adminActions';

export default function SessionPage() {
  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [token, setToken] = useState<string | null>(null);
  const supabase = createClient();
  const router = useRouter();

  useEffect(() => {
    const checkUser = async () => {
      try {
        const {
          data: { session }
        } = await supabase.auth.getSession();

        if (!session) {
          router.push('/signin');
          return;
        }

        const userGroups = await getUserGroup();
        if (userGroups.includes('TEST') || userGroups.includes('STAFF')) {
          setIsAuthorized(true);
          setToken(session.access_token);
        } else {
          router.push('/');
          return;
        }
      } catch (error) {
        console.error('Error checking user:', error);
        router.push('/signin');
      } finally {
        setIsLoading(false);
      }
    };

    checkUser();
  }, [router]);

  if (isLoading) return <div>Loading...</div>;
  if (isAuthorized === null) return <div>Checking authorization...</div>;
  if (!isAuthorized) return <div>Not authorized</div>;

  return (
    <main className="p-6 bg-black w-full min-h-screen text-white">
      <h1 className="text-2xl font-bold mb-4">Session Token</h1>
      <pre className="bg-zinc-900 p-4 rounded break-all whitespace-pre-wrap text-sm">
        {token}
      </pre>
    </main>
  );
}
